/* Purr Thru landing (22.10.2026): one product,
   tiers (the arch Buy 1/2/3, price per item), the «+30 days of guarantee» add-on (checkbox in the buy box + offer in the
   drawer, max 1 per order), a cart drawer kept in localStorage, the «make it 2» swap offer (Buy 1 → the 2-pack variant), shipping
   protection ON by default (owner 22.10; an untick by the buyer is kept with the saved cart), delivery estimate in business days,
   sticky add-to-cart, one geo switch to the visitor's currency. Every price comes from the variants in the buyer's presentment
   currency (Liquid → #m-data), USD literals only in DEMO mode. No popup, no countdown, no fake urgency.
   24.10 owner: the arch is sold ONLY as bundle variants (Buy 1/2/3) — no quantity control anywhere, ONE arch line with quantity 1
   (another bundle replaces the line = switches the variant, the same bundle again changes nothing); the «make it 2» offer
   switches the variant; a saved cart with q > 1 loads as q 1. The guarantee add-on keeps its own rule (max 1, only with an arch).
   Checkout = cart permalink /cart/<variant>:1,… when products are connected; DEMO mode shows a toast instead.
   Live guard (below, also on /cart): Shopify's own cart (/cart.js) is fixed on every page load — an arch line with quantity > 1
   → 1, a second arch line → 0 (the guarantee and shipping protection are not touched), so a direct /cart/add.js with
   quantity 2 never reaches the checkout as 2. */
(function () {   // live cart guard: one line per main product, quantity 1 (owner 24.10)
  var lm = document.querySelector('.m[data-demo]');
  if ((lm && lm.dataset.demo === 'true') || !window.fetch || !window.Promise) return;   // DEMO landing: nothing is connected
  var HANDLES = ['purr-thru-cat-grooming-arch'], VIDS = {};
  try { var J = JSON.parse(document.getElementById('m-data').textContent);
    ['t0', 't1', 't2'].forEach(function (k) { if (J[k] && J[k].vid) VIDS[String(J[k].vid)] = 1; }); } catch (e) {}
  var H = { 'Content-Type': 'application/json', Accept: 'application/json' }, de = document.documentElement;
  fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
    .then(function (c) {
      var seen = {}, ops = [], chain = Promise.resolve();
      (c.items || []).forEach(function (it) {
        if (!VIDS[String(it.variant_id)] && HANDLES.indexOf(it.handle) < 0) return;   // the guarantee / protection keep their own logic
        if (seen[it.product_id]) ops.push([it.key, 0]); else { seen[it.product_id] = 1; if (it.quantity > 1) ops.push([it.key, 1]); } });
      ops.forEach(function (o) { chain = chain.then(function () {   // sequentially: Shopify's cart API does not like parallel changes
        return fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: H, body: JSON.stringify({ id: o[0], quantity: o[1] }) }); }); });
      return chain.then(function () { de.setAttribute('data-cart-guard', 'done:' + ops.length);
        if (ops.length && document.querySelector('.m-simple__cart')) location.reload(); });   // the /cart page shows the fixed cart
    }).catch(function () { de.setAttribute('data-cart-guard', 'error'); });
})();
(function () {
  var root = document.querySelector('.m'); if (!root || !document.querySelector('#m-data')) return;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var D = root.dataset, demo = D.demo === 'true', STRIKE = D.strike !== 'false', CUR = D.cur || '$';
  var PROT = parseFloat(String(D.protPrice).replace(',', '.')) || 0;
  var store = {
    get: function (k) { try { return localStorage.getItem('pt_' + k); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem('pt_' + k, v); } catch (e) {} } };
  var I = JSON.parse($('#m-data').textContent);
  var ARCH = ['t0', 't1', 't2'], ALL = ARCH.concat(['g']);
  var st = { kit: 't0' };
  var cart = { lines: {}, prot: D.protDefault === 'true' };
  try { var saved = JSON.parse(store.get('cart') || 'null');
    // one arch line (the biggest saved bundle) + the guarantee, quantity always 1 — an old saved «3 × Buy 1» loads as 1 × Buy 1
    if (saved && saved.lines) { var keep = null; ARCH.forEach(function (k) { if (+saved.lines[k] > 0) keep = k; });
      if (keep) cart.lines[keep] = 1; if (+saved.lines.g > 0) cart.lines.g = 1;
      if (saved.protSet) { cart.prot = !!saved.prot; cart.protSet = true; } } } catch (e) {}   // only the buyer's own choice overrides the default
  function save() { store.set('cart', JSON.stringify(cart)); }

  // live mode: the theme's JSON comes from the variants; warn if a price and its variant disagree
  if (!demo) ALL.forEach(function (k) { var it = I[k];
    if (it.vprice != null && it.price != null && Math.round(it.vprice) !== Math.round(it.price * 100)) console.warn('[pt] price mismatch', k, it.price, it.vprice / 100); });

  function r2(v) { return Math.round(v * 100 + 1e-6) / 100; }
  var NF = null; try { if (D.iso) NF = new Intl.NumberFormat('en', { style: 'currency', currency: D.iso }); } catch (e) {}
  function money(v) { return NF ? NF.format(r2(v)) : CUR + r2(v).toFixed(2); }
  // one automatic switch to the visitor's country (= local currency) by IP, only to a country the store sells to
  if (!demo && !store.get('geo')) {
    store.set('geo', '1');
    fetch('/browsing_context_suggestions.json?country[enabled]=true&currency[enabled]=true').then(function (r) { return r.json(); })
      .then(function (d) {
        var c = d && d.detected_values && d.detected_values.country && d.detected_values.country.handle;
        if (!c || c === D.country || !$('#m-country') || !$('#m-country option[value="' + c + '"]')) return;
        var f = document.createElement('form'); f.method = 'post'; f.action = '/localization'; f.style.display = 'none';
        [['form_type', 'localization'], ['utf8', '✓'], ['_method', 'put'], ['country_code', c], ['return_to', location.pathname + location.search]]
          .forEach(function (kv) { var i = document.createElement('input'); i.type = 'hidden'; i.name = kv[0]; i.value = kv[1]; f.appendChild(i); });
        document.body.appendChild(f); f.submit();
      }).catch(function () {});
  }
  function was(it) { return STRIKE && it.was > it.price ? it.was : it.price; }
  function pct(it) { var w = was(it); return w > it.price ? Math.round((w - it.price) * 100 / w) : 0; }
  function toast(t) { var el = $('#m-toast'); el.textContent = t; el.hidden = false; clearTimeout(el._t); el._t = setTimeout(function () { el.hidden = true; }, 3200); }
  function setImg(src) { var m = $('#m-main'); if (!src || !m || m.getAttribute('src') === src) return; m.style.opacity = 0;
    setTimeout(function () { m.src = src; m.style.opacity = 1; }, 140);
    $$('.m-thumb').forEach(function (t) { t.classList.toggle('is-on', t.dataset.src === src); }); }

  /* ---------- delivery estimate (business days, Mon–Fri) ---------- */
  function addBiz(d, n) { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) n--; } return d; }
  function fmt(d) { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); }
  try {
    var now = new Date(), s1 = +D.shipMin || 3, s2 = +D.shipMax || 6, d1 = +D.delMin || 6, d2 = +D.delMax || 9;
    $('#m-d-order').textContent = fmt(now);
    $('#m-d-ship').textContent = fmt(addBiz(now, s1)) + ' – ' + fmt(addBiz(now, s2));
    $('#m-d-deliv').textContent = fmt(addBiz(now, s1 + d1)) + ' – ' + fmt(addBiz(now, s2 + d2));
  } catch (e) {}

  /* ---------- buy box ---------- */
  $$('[data-guar-price]').forEach(function (el) { el.textContent = money(I.g.price); });
  $$('[data-prot-m]').forEach(function (el) { el.textContent = money(PROT); });   // one number format for every price (Liquid money writes «€3,59»)
  ARCH.forEach(function (k) { var it = I[k], pp = $('[data-pp="' + k + '"]'), sv = $('[data-save="' + k + '"]'),
      tp = $('[data-tp="' + k + '"]'), tw = $('[data-tw="' + k + '"]'), w = was(it);
    if (pp) pp.textContent = it.n > 1 ? money(it.price / it.n) + ' each' : '';
    if (sv) sv.textContent = pct(it) ? 'Save ' + pct(it) + '%' : '';
    if (tp) tp.textContent = money(it.price);
    if (tw) tw.textContent = w > it.price ? money(w) : ''; });
  function hasG() { return (cart.lines.g || 0) > 0; }
  function renderBuy() {
    var key = st.kit, it = I[key], w = was(it);
    $$('.m-tier').forEach(function (t) { var on = t.dataset.key === key; t.classList.toggle('is-on', on); t.setAttribute('aria-checked', on); });
    $('#m-price').textContent = money(it.price);
    $('#m-was').textContent = w > it.price ? money(w) : '';
    $('#m-off').hidden = !(w > it.price); $('#m-off').textContent = 'Save ' + pct(it) + '%';
    var unit = it.n > 1 ? it.n + ' ' + it.unit + 'es · ' + money(it.price / it.n) + ' each' : '1 ' + it.unit + ' · free tracked shipping';
    if (w > it.price) unit += ' · you save ' + money(w - it.price);
    $('#m-unit').textContent = unit;
    var g = $('#m-addon') && $('#m-addon').checked && !hasG() ? I.g.price : 0;
    $('#m-buy-price').textContent = money(it.price + g);
    $('#m-sticky-name').textContent = it.short + ' — ' + it.n + ' ' + it.unit + (it.n > 1 ? 'es' : '');
    $('#m-sticky-price').textContent = money(it.price);
  }
  $$('.m-tier').forEach(function (t) { t.addEventListener('click', function () { st.kit = t.dataset.key; renderBuy(); }); });
  $$('.m-thumb').forEach(function (t) { t.addEventListener('click', function () { setImg(t.dataset.src); }); });
  $$('[data-pick]').forEach(function (a) { a.addEventListener('click', function () { st.kit = a.dataset.pick; renderBuy(); }); });
  if ($('#m-addon')) $('#m-addon').addEventListener('change', renderBuy);

  /* ---------- cart drawer ---------- */
  var drawer = $('#m-drawer'), overlay = $('#m-overlay');
  function openCart() { renderCart(); drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); overlay.hidden = false; document.body.style.overflow = 'hidden'; stickyUpd(); }
  function closeCart() { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); overlay.hidden = true; document.body.style.overflow = ''; stickyUpd(); }
  $$('[data-open-cart]').forEach(function (b) { b.addEventListener('click', openCart); });
  $$('[data-close-cart]').forEach(function (b) { b.addEventListener('click', closeCart); });
  overlay.addEventListener('click', closeCart);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });

  function cnt(keys) { return keys.reduce(function (a, k) { return a + (cart.lines[k] || 0); }, 0); }
  // one arch line, quantity 1 (owner 24.10): another bundle REPLACES the arch line (= switches the variant); the same bundle
  // again = no change; the guarantee is a separate add-on line (max 1). Returns true when the cart changed.
  function setLine(k) { if (cart.lines[k]) return false; if (k !== 'g') ARCH.forEach(function (x) { delete cart.lines[x]; }); cart.lines[k] = 1; return true; }
  function arch() { for (var i = 0; i < ARCH.length; i++) if (cart.lines[ARCH[i]]) return ARCH[i]; return null; }
  function label(k) { var it = I[k]; return it.n + ' ' + it.unit + (it.n > 1 ? 'es' : ''); }
  function buy() {
    var had = arch(), ch = setLine(st.kit), ad = false;
    if ($('#m-addon') && $('#m-addon').checked) ad = setLine('g');
    save(); openCart();
    if (!ch && !ad) toast('Already in your cart'); else if (ch && had) toast('Switched to ' + label(st.kit));
  }
  $('#m-buy').addEventListener('click', buy);
  $('#m-sticky-add').addEventListener('click', buy);
  // swap offer: the single arch → the 2-pack VARIANT (only while «Buy 1» is the arch line)
  function canUp() { return !!cart.lines.t0; }
  $('#m-up-btn').addEventListener('click', function () {
    if (!canUp()) return; setLine('t1'); save(); renderCart(); toast('Upgraded to 2 arches'); });
  $('#m-g-up-btn').addEventListener('click', function () { if (!hasG()) { setLine('g'); save(); renderCart(); renderBuy(); toast('Guarantee extended to 60 days'); } });
  $('#m-prot').addEventListener('change', function (e) { cart.prot = e.target.checked; cart.protSet = true; save(); renderCart(); });

  function lineHtml(k) {   // no quantity control: the bundle IS the quantity (owner 24.10)
    var it = I[k], w = was(it);
    return '<div class="m-line" data-line="' + k + '"><img src="' + it.thumb + '" alt=""><div><b>' + it.title + '</b><small>' + it.sub + '</small></div>' +
      '<div class="m-line__p">' + (w > it.price ? '<s>' + money(w) + '</s>' : '') + '<b>' + money(it.price) + '</b>' +
      '<button type="button" class="m-line__rm" data-rm="' + k + '">Remove</button></div></div>';
  }
  function renderCart() {
    var html = '', goods = 0, full = 0, n = 0, arches = cnt(ARCH);
    if (!arches && hasG()) { delete cart.lines.g; save(); }   // the guarantee extension only goes with an arch
    ALL.forEach(function (k) { if (!cart.lines[k]) return; cart.lines[k] = 1;
      html += lineHtml(k); goods += I[k].price; full += was(I[k]); n += 1; });
    $('#m-lines').innerHTML = html;
    var empty = !n;
    $('#m-empty').hidden = !empty; $('#m-checkout').disabled = empty;
    $('#m-up').hidden = !canUp();
    $('#m-up-price').textContent = '+' + money(I.t1.price - I.t0.price);
    $('#m-g-up').hidden = !(arches && !hasG());
    $('#m-prot').checked = cart.prot;
    var prot = cart.prot && !empty ? PROT : 0;
    $('#m-sum-goods').textContent = money(goods); $('#m-sum-was').textContent = full > goods + 0.001 ? money(full) : '';
    $('#m-sum-prot-row').hidden = !prot; $('#m-sum-prot').textContent = money(prot);
    $('#m-sum-total').textContent = money(goods + prot);
    var sv = full - goods; $('#m-saved').textContent = sv > 0.004 ? 'You save ' + money(sv) : '';
    $('#m-count').textContent = n; $('#m-count').hidden = !n;
  }
  $('#m-lines').addEventListener('click', function (e) {
    var rm = e.target.closest('[data-rm]');
    if (rm) { delete cart.lines[rm.dataset.rm]; save(); renderCart(); renderBuy(); }
  });
  $('#m-checkout').addEventListener('click', function () {
    var ids = {}, ok = true;
    function put(v) { if (!v) { ok = false; return; } ids[v] = 1; }   // quantity 1 per line, always
    Object.keys(cart.lines).forEach(function (k) { if (cart.lines[k]) put(I[k].vid); });
    if (cart.prot) put(I.prot.vid);
    if (demo || !ok) { toast('Sales open soon — this is a store preview.'); return; }
    location.href = '/cart/' + Object.keys(ids).map(function (v) { return v + ':' + ids[v]; }).join(',');
  });

  /* ---------- sticky ---------- */
  var buyBtn = $('#m-buy'), sticky = $('#m-sticky');
  function stickyUpd() { if (!buyBtn || !sticky) return; sticky.hidden = buyBtn.getBoundingClientRect().bottom > 0 || drawer.classList.contains('is-open'); }
  window.addEventListener('scroll', stickyUpd, { passive: true }); stickyUpd();

  renderBuy(); renderCart();
})();
